import { RootState } from 'index'

export const selectRegionsData = (state: RootState) => state.regions
